import PropTypes from 'prop-types';
import { fDateTime } from 'src/utils/formatTime';
import { mascararTel } from 'src/utils/functions';
import Iconify from 'src/components/Iconify';
import { Badge } from 'src/@/components/ui/badge';
import { GENERIC_TABLE_DESIGN } from 'src/components/table/GenericTable.design';
import { RELATORIOS_DESIGN as d } from './Relatorios.design';

function getNotaBadge(nota) {
    const n = Number(nota);
    if (n >= 4) return { className: d.badges.nota.high, icon: 'eva:star-fill', color: 'text-green-500' };
    if (n >= 3) return { className: d.badges.nota.medium, icon: 'eva:star-fill', color: 'text-amber-500' };
    return { className: d.badges.nota.low, icon: 'eva:star-fill', color: 'text-red-500' };
}

AvaliacoesRow.propTypes = {
    row: PropTypes.object.isRequired,
};

export default function AvaliacoesRow({ row }) {
    const { nomeCliente, telefone, dataAvaliacao, atendente, nota } = row;
    const badge = getNotaBadge(nota);

    return (
        <div className={GENERIC_TABLE_DESIGN.row.container}>
            <div className="flex-[2] min-w-[180px] pr-4">
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-violet-50 flex items-center justify-center flex-shrink-0">
                        <Iconify icon="eva:person-outline" width={16} className="text-violet-600" />
                    </div>
                    <span className="text-sm font-semibold text-gray-900 truncate">{nomeCliente || '-'}</span>
                </div>
            </div>
            <div className="flex-1 min-w-[130px]">
                <span className="text-sm text-gray-600 font-mono">{mascararTel(telefone) || '-'}</span>
            </div>
            <div className="flex-1 min-w-[150px]">
                <span className="text-sm text-gray-600">{fDateTime(dataAvaliacao) || '-'}</span>
            </div>
            <div className="flex-1 min-w-[150px]">
                <div className="flex items-center gap-2">
                    <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                        <Iconify icon="eva:person-outline" width={12} className="text-gray-500" />
                    </div>
                    <span className="text-sm text-gray-700 truncate">{atendente || '-'}</span>
                </div>
            </div>
            <div className="w-[100px] text-center flex justify-center">
                <Badge variant="outline" className={badge.className}>
                    <Iconify icon={badge.icon} width={12} className={badge.color} />
                    {nota}
                </Badge>
            </div>
        </div>
    );
}
